import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView, useMotionValue, useSpring } from 'framer-motion';
const Counter = ({
  value,
  suffix = ''
}: {
  value: number;
  suffix?: string;
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, {
    duration: 2000,
    bounce: 0
  });
  const [displayValue, setDisplayValue] = useState(0);
  useEffect(() => {
    if (inView) {
      motionValue.set(value);
    }
  }, [inView, motionValue, value]);
  useEffect(() => {
    return springValue.on('change', latest => {
      setDisplayValue(Math.floor(latest));
    });
  }, [springValue]);
  return <span ref={ref} data-id="element-171">
      {displayValue}
      {suffix}
    </span>;
};
export const Stats = () => {
  return <motion.section className="py-32 bg-gradient-to-br from-[#0a192f] to-[#2d1b4e] relative overflow-hidden" initial={{
    scale: 1.1,
    opacity: 0
  }} whileInView={{
    scale: 1,
    opacity: 1
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 1,
    ease: 'easeOut'
  }} data-id="element-172">
      <div className="container mx-auto px-6 relative z-10" data-id="element-173">
        <motion.h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-white mb-20" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-174">
          Los números que tu negocio necesita conocer
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center" data-id="element-175">
          {[{
          num: 73,
          suffix: '%',
          text: 'de personas busca online antes de comprar',
          delay: 0
        }, {
          num: 81,
          suffix: '%',
          text: 'de usuarios juzga tu credibilidad por tu web',
          delay: 0.2
        }, {
          num: 3,
          suffix: ' seg',
          text: 'tardás en perder un cliente sin web',
          delay: 0.4
        }].map((stat, i) => <motion.div key={i} className="flex flex-col items-center" initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: stat.delay,
          duration: 0.8
        }} data-id="element-176">
              <div className="text-6xl md:text-8xl font-serif font-bold text-primary mb-6 drop-shadow-[0_0_15px_rgba(212,175,55,0.3)]" data-id="element-177">
                <Counter value={stat.num} suffix={stat.suffix} data-id="element-178" />
              </div>
              <p className="text-xl text-text-secondary max-w-xs leading-relaxed" data-id="element-179">
                {stat.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </motion.section>;
};